import { UPLOADIMAGE, CREATEHEADER } from "./actionTypes";
import { Toastify } from "../../services/toastify/toastifyContainer";
import { apicall } from "../../services/api";

//upload Image 
export const uploadImage = (image) => async (dispatch) => {
	try {
		const res = await apicall("/dash/uploadImage","post", image, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
		if (res.status === 201) {

			Toastify({ data: "success", msg: res?.data?.message })
		}
		dispatch({
			type: UPLOADIMAGE,
			payload: res?.data?.data,
		});
		return res?.data?.data
	} catch (err) {
		console.log(err);
		Toastify({ data: "error", msg: err?.response?.data?.message })
	}
};

// create Header 
export const createHeader = (data) => async (dispatch) => {

	try {
		const res = await apicall("/dash/createHeader","post", {
			left_nav_logo: data.left_nav_logo,
			nav_lists: data.navList,
			nav_right_logo: data.nav_right_logo,
			campaign_Id: data.campaignId,
			ui_type: data.uiType
		})
		if (res.status === 201 && res.data.success === true) {
			Toastify({ data: "success", msg: res?.data?.message })
			localStorage.setItem("uiType", res.data.data.ui_type)
			localStorage.setItem("campaignId", res.data.data.campaign_Id)
		}
		dispatch({
			type: CREATEHEADER,
			payload: res.data,
		});
		return res.data
	} catch (err) {
		console.log(err);
		Toastify({ data: "error", msg: err?.response?.data?.message })

	}
};
// create Body 
export const createBody = (data) => async (dispatch) => {
	let body = {
		main_banner_desktop: data.main_banner_desktop,
		detail_banner_desktop: data.detail_banner_desktop,
		detail_banner_mobile: data.detail_banner_mobile,
		main_banner_mobile: data.main_banner_mobile,
		main_heading: data.main_heading,
		main_subHeading: data.main_subHeading,
		disclaimer: data.disclaimer,
		campaign_Id: data.campaignId,
		ui_type: data.uiType,
		partners: data?.partners,
		partners_heading: data?.partners_heading,
		partners_subHeading: data?.partners_subHeading,
		created_by:data?.created_by
	}

	if (data?.promotional_banner_desktop?.[0]?.image) {
		body.promotional_banner_desktop = data.promotional_banner_desktop;
	}
	if (data?.promotional_banner_mobile?.[0]?.image) {
		body.promotional_banner_mobile = data.promotional_banner_mobile;
	}

	try {
		const res = await apicall("/dash/createBody/external","post", body)
		if (res.status === 201 && res.data.success === true) {
			Toastify({ data: "success", msg: res?.data?.message })
		}
		return res.data
	} catch (err) {
		console.log(err);
		Toastify({ data: "error", msg: err?.response?.data?.message })

	}
};
